/*global $*/
import React from "react";
import { connect } from "react-redux";

import { callService, formatDateDMA, makeform, goTo } from "./../tools";
import { servicios } from "./../properties";
import CardPoliza from "./cardPoliza.cmpt";
import ListPoliza from "./listPoliza.cmpt";
import VidaProducto from "./productos/vidaProducto.cmpt";
import AutosProducto from "./productos/autosProducto.cmpt";
import DaniosProducto from "./productos/daniosProducto.cmpt";
import GastosProducto from "./productos/gastosProducto.cmpt";
import { agregarPoliza, obtenerMediosContacto, generarOtpBan, detailPoliza, actualizaPersona, updatePersona } from "./polizas.act";
import DetallePoliza from "./detalle.cmpt";
import PolizaForm from "./poliza.frm";
import CallCenterForm from "./callCenter.frm"
import ModalCodigoVerificacion from "../miPerfil/modalCodigoVerificacion.cmpt";

import "./estilos_h.css"
import ModalDinamico from "../modalDinamico.cmpt";
import { getDatosRegimenFiscal } from "../miPerfil/datosfiscales.act";

const mapState = (state) => {
	return {
		"clienteUnico": state.global.clienteUnico,
		"tokenId": state.global.tid,
		"loading": state.global.loading,
		"refreshToken": state.global.refreshToken,
		"autos": state.polizas.autos,
		"gm": state.polizas.gm,
		"vida": state.polizas.vida,
		"danios": state.polizas.danios,
		"paso": state.registro.paso,
		"polizasAutos": state.polizas.autos.length,
		"polizasGm": state.polizas.gm.length,
		"polizasVida": state.polizas.vida.length,
		"polizasDanios": state.polizas.danios.length,
		"lastlogin": state.global.lastlogin,
		"ramo": state.polizas.ramoActual,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		setDetalle: (oPoliza) => {
			dispatch({ "type": "SET_DETALLE_POLIZA", "poliza": oPoliza });
			dispatch({ "type": "SET_POLIZA_SELECCIONADA", "polizaSeleccionada": oPoliza.generales.numPoliza });
		},
		setRamoActual: (ramo) => {
			dispatch({ "type": "SET_RAMO_ACTUAL", "ramoActual": ramo });
		},
		agregarPoliza: sDatos => {
			dispatch(agregarPoliza(sDatos));
		},
		mostrarMensajePolizaAgregada: (sTitulo, sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": sTitulo, "mensaje": sMensaje });
		},
		obtenerMediosContacto: () => {
			dispatch(obtenerMediosContacto());
		},
		generarOtpBan: (item) => {
			dispatch(generarOtpBan(item));
		},
		setPolizaFalse: () => {
			dispatch({ "type": "SET_POLIZA_VALIDA", "valida": false });
		},
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const limpiar = (value) => {
	return (value != undefined) ? value.replace(/\s/g, "").toUpperCase() : "";
};

class Polizas extends React.Component {
	state = {
		"showModal":false,
		"tabAutos": "",
		"tabGm": "",
		"tabVida": "",
		"tabDaños": "",
		"tabTodas": "active",
		"verPolizas": true,
		"agregarPoliza": false,
		"videollamada": false,
		"card": true,
		"images": [
			require("../img/icon-cards-normal.svg"),
			require("../img/icon-cards-active.svg"),
			require("../img/icon-lista-normal.svg"),
			require("../img/icon-lista-active.svg")
		],
		"mobileTabs": false,
		"tienePolizas": false,
		"claseLista": "",
		"secondMenuTitle": "Todas",
		"arrow": [
			require("../img/arrow-down.svg"),
			require("../img/arrow-up.svg")
		],
		"arrowIndex": 0,
		"autosArrowIndex": 0,
		"gmArrowIndex": 0,
		"dañosArrowIndex": 0,
		"vidaArrowIndex": 0,
		"ramo": "Todas",
		"bgClass": "autos-bg",
		"listDisable": true,
		"cardDisable": false,
		"showProducto": false,
		"modalDin":{
			fnBtnDer:()=>{},
			fnBtnIzq:()=>{},
			txtBtnDer:"",
			txtBtnIzq:"",
			titulo:"",
			mensaje:"",
			imagenHeaderUrl:"",
			hasClose:false,
		},

	}

	clearTabs = () => {
		this.setState({
			"tabAutos": "",
			"tabGm": "",
			"tabVida": "",
			"tabDaños": "",
			"tabTodas": "",
		});
	}

	selectTab = (sTab) => {
		console.log(sTab[0]);

		try { event.preventDefault(); } catch (e) { }

		let sRamo = "";
		var claseLista = "";
		var bgClass;

		switch (sTab[0]) {
			case "tabAutos":
				sRamo = "Autos";
				bgClass = "autos-bg";
				this.props.addEvento("select-TabAuto");
				if (this.props.autos.length != 0) {
					claseLista = "lista-wrap";
				}
				break;
			case "tabGm":
				sRamo = "Gastos Médicos Mayores";
				bgClass = "gmm-bg";
				this.props.addEvento("select-TabGMM");
				if (this.props.gm.length != 0) {
					claseLista = "lista-wrap";
				}
				break;
			case "tabVida":
				sRamo = "Vida";
				bgClass = "vida-bg";
				this.props.addEvento("select-TabVida");
				if (this.props.vida.length != 0) {
					claseLista = "lista-wrap";
				}
				break;
			case "tabDaños":
				sRamo = "Daños";
				bgClass = "danios-bg";
				this.props.addEvento("select-TabDanos");
				if (this.props.danios.length != 0) {
					claseLista = "lista-wrap";
				}
				break;
			case "tabTodas":
				sRamo = "Todas";
				bgClass = "autos-bg";
				this.props.addEvento("select-TabTodas");
		}

		this.clearTabs();
		let state = {
			"secondMenuTitle": sTab[1],
			"ramo": sRamo,
			"agregarPoliza": false,
			"videollamada": false,
			"claseLista": claseLista,
			"bgClass": bgClass,
			"showProducto": false
		};
		state[sTab[0]] = "active";
		this.props.setRamoActual(sRamo);

		this.setState(state);
		this.showMobileTabs();
	}

	componentWillMount = () => {
		this.props.loader(false);
		console.info("componentWillMount Ramo actual: ", this.props.ramo);
		var ramo;
		var tab;
		switch (this.props.ramo) {
			case "A":
				ramo = "Autos";
				tab = "tabAutos";
				break;
			case "G":
				ramo = "Gastos Médicos Mayores";
				tab = "tabGm";
				break;
			case "D":
				ramo = "Daños";
				tab = "tabDaños";
				break;
			case "V":
				ramo = "Vida";
				tab = "tabVida";
				this.props.obtenerMediosContacto();
				break;
			case "T":
				ramo = "Todas";
				tab = "tabTodas";
				this.props.obtenerMediosContacto();
				break;
			default:
				ramo = "Todas";
				tab = "tabTodas";
				this.props.obtenerMediosContacto();
		}

		var temporal = {
			"tabAutos": "",
			"tabGm": "",
			"tabVida": "",
			"tabDaños": "",
			"tabTodas": "",
			"ramo": ramo,
			"secondMenuTitle": ramo
		};

		temporal[tab] = "active";
		// console.log(temporal);

		this.setState(temporal);
		this.setState(temporal);

		this.setState(temporal);
		const clienteUnico = this.props.clienteUnico;
		const tid = this.props.tokenId;
		getDatosRegimenFiscal(clienteUnico,tid).then((res)=>{
			console.log(res);
			this.setState({showModal:false});
			if(res.status === 202){
				console.log('202');
				if(res.data !== undefined && res.data.modal !== undefined && res.data.modal === true){
					console.log('dentro de la validacion');
					this.showRegimenFiscalModal(true);
				}
			}
		}).catch((err)=>{
			console.log("Error DatosFiscales:"+ err);
		});
	}

	showRegimenFiscalModal(show){
		this.setState({showModal:show});
		const modalData = {
			fnBtnDer:()=>{},
			fnBtnIzq:()=>{goTo("mi-perfil/regimen-fiscal");},
			txtBtnDer:"Hacerlo más tarde",
			txtBtnIzq:"Ingresar datos ahora",
			titulo:"Aviso importante",
			mensaje:
			<p><strong>Actualiza tus datos fiscales</strong> para seguir utilizando tu Seguro GNP en tu declaración de impuestos <strong>para deducir.</strong>
				<br/><br/>Si no utilizas tu factura para fines fiscales, puedes omitir este mensaje.  
			</p>,
			imagenHeaderUrl:require("../img/info_outline.svg"),
			hasClose:true,
		};
		this.setState({modalDin: modalData})
	}

	componentDidMount = () => {
		var claseLista = "";
		if (this.props.autos.length != 0) {
			claseLista = "lista-wrap";
		}
		this.setState({
			"claseLista": claseLista,
		});
	}

	showModalViaNomina = () =>{
		this.setState({showModal: true});
		const modalData = {
			fnBtnIzq:()=>{},
			txtBtnDer:"",
			txtBtnIzq:"Entendido",
			titulo:"Renovación vía nómina",
			mensaje:<p className="text-modal-via-nomina">Esta póliza se encuentra instalada en un proceso 
			de cobro a través de la nómina de tu dependencia de trabajo y se renovará de forma automática. 
			Para cualquier modificación contacta con tu módulo de seguros.</p>,
			imagenHeaderUrl: require("../img/renovacion-via-nomina.png"),
			hasClose:true,
		};
		this.setState({modalDin: modalData});
	}

	setDetalle = (item) => {
		console.log("setDetalle corriendo");
		this.props.setRamoActual(item[1]);

		if (item[0].generales.ramo == "Vida" && (item[0].generales.detalle == "capitaliza" || item[0].generales.detalle == "inversion")) {
			item[0].clienteUnico = this.props.clienteUnico;
			this.props.generarOtpBan(item[0]);
			this.props.setDetalle(item[0]);
			$("#modal-codigo-pol").modal("toggle");
		} else {
			this.props.setDetalle(item[0]);
			goTo("detalle/" + item[0].generales.numPoliza);
		}
	}

	openDetalle = (item) => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({ service: "encripta", secure: true, data: { "lista": [{ "campo": "poliza", "valor": item.generales.numPoliza }] } }).execute();
		llamaServicio.then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);

			if (item.generales.detalle == "capitaliza") {
				makeform(servicios.polizas.vidaCapitaliza, {
					"emailV": respuesta.email,
					"numeroPolizaV": respuesta.poliza
				}, "POST");
			} else {
				makeform(servicios.polizas.vidaInversion, {
					"correo": respuesta.email,
					"numPoliza": respuesta.poliza,
					"codFiliacion": respuesta.ccu,
					"nombreCompleto": respuesta.nombre
				}, "GET");
			}

		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alerta("Problemas al generar el detalle");
		});
	}

	openAuthLtpa = (item) => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({ service: "otp.validarOtpBan", secure: true, data: { "refreshtoken": this.props.refreshToken } }).execute();
		llamaServicio.then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.openDetalle(item);
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alerta("Problemas al generar el detalle");
		});

	}

	verPolizas = () => {
		this.setState({ "verPolizas": true });
	}

	toggleView = (event) => {
		let flag = event.target.name == "true" ? true : false;
		let visor = event.target.alt;
		console.log(visor);
		this.props.addEvento("ModoVisualizar - " + visor);
		var claseLista = "";
		if (this.state.tabAutos == "active") {
			if (this.props.autos.length != 0) {
				claseLista = "lista-wrap";
			}
		} else if (this.state.tabGm == "active") {
			if (this.props.gm.length != 0) {
				claseLista = "lista-wrap";
			}
		} else if (this.state.tabVida == "active") {
			if (this.props.vida.length != 0) {
				claseLista = "lista-wrap";
			}
		} else if (this.state.tabDaños == "active") {
			if (this.props.danios.length != 0) {
				claseLista = "lista-wrap";
			}
		}

		this.setState({
			card: flag,
			claseLista: claseLista,
			listDisable: !this.state.listDisable,
			cardDisable: !this.state.cardDisable
		});
	}

	toggleProducto = () => {
		console.log("toggleProducto corriendo");
		this.setState({
			"showProducto": !this.state.showProducto
		});
		this.props.addEvento("Producto - " + this.state.ramo);
	}

	showMobileTabs = () => {
		var arrowIndex;
		if (this.state.arrowIndex == 1) {
			arrowIndex = 0;
		} else if (this.state.arrowIndex == 0) {
			arrowIndex = 1;
		}
		this.setState({
			"mobileTabs": !this.state.mobileTabs,
			"arrowIndex": arrowIndex
		});
	}

	agregarToggle = () => {
		this.setState({
			"agregarPoliza": !this.state.agregarPoliza,
		});
		this.props.addEvento("Boton-AgregarPoliza");
	}

	videoToggle = () => {//
		this.setState({
			"videollamada": !this.state.videollamada,
		});
		this.props.addEvento("Boton-AgregarPoliza");
	}

	toggleTodas = (tipo) => {
		var temporal = {};
		var index = 0;
		if (this.state[tipo] == 0) {
			index = 1;
		}
		temporal[tipo] = index;
		this.setState(temporal);
	}

	submit = (data) => {
		let $this = this;
		let hoy = new Date();
		$this.props.loader(true);

		let poliza = data.poliza1;
		if (data.sistema == "INFO") {
			while (poliza.length < 14) {
				poliza = "0" + poliza;
			}
		}

		if (data.polizaReal && parseInt(data.poliza) != parseInt(data.polizaReal)) {
			data.poliza = data.polizaReal;
		}

		/*let llamaServicio = new callService({
			service: "utilerias.detallePoliza",
			secure: true,
			data: { poliza: poliza }
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);

		}).catch((error) => {
			console.log("Error", error);

		});*/

		/*
		detallePoliza({
			"poliza": poliza
		}).then(resultado => {
			console.log("Respuesta", resultado);
			actualizaPersona(this.props.clienteUnico, resultado)
			.then(r=>{
					console.log("r" + r);
			}
				);

		}).catch(error => {
			console.log(error);
			$this.props.loader(false);
			if (error.message.mensaje) {
				$this.props.mostrarMensajePolizaAgregada("Importante", error.message.mensaje);
			} else {
				$this.props.mostrarMensajePolizaAgregada("ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
			}
		}); */

		/*actualizaPolizaAgregada({
			codigoFiliacion: this.props.clienteUnico,
			idParticipante: idParticipante,
			RFC: RFC,
			fechaNacimiento: fechaNacimiento,
			apellidoPaterno: apaterno,
			nombre: nombres,
			"usuarioAudit": "operadorcrm"

		}).then(resultado =>{

		}).catch(error => {
			console.log(error);
			$this.props.loader(false);
			if(error.message.mensaje){
				$this.props.mostrarMensajePolizaAgregada("Importante", error.message.mensaje);
			} else {
				$this.props.mostrarMensajePolizaAgregada("ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
			}
		}*/


		//console.log("---- " + data.rfcbnmx);

		/*updatePersona(
			this.props.clienteUnico,
			data.rfcbnmx,
			data.anioNacimiento + data.mesNacimiento + data.diaNacimiento
		).then(resultado => {
			console.log(resultado);
			//actualizaPersona(this.props.clienteUnico, resultado);
			$this.props.tagManager({ "type": "EVENT_MISPOLIZAS_APOLIZA-CORRECTOS", "dispositivo": $this.props.dispositivo });
		}).catch(error => {
			console.log(error);
			//$this.props.loader(false);
			/*if (error.message.mensaje) {
				$this.props.mostrarMensajePolizaAgregada("Importante", error.message.mensaje);
			} else {
				$this.props.mostrarMensajePolizaAgregada("ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
			}*/
		//});
		if (data.rfcbnmx != undefined && data.anioNacimiento != 0 && data.mesNacimiento != 0 && data.diaNacimiento != 0) {
			var fechaNac = data.anioNacimiento + data.mesNacimiento + data.diaNacimiento;
			detailPoliza({
				"poliza": poliza
			}).then(resultado => {
				//console.log(resultado);
				console.log("persona actualizada OK");
				actualizaPersona(this.props.clienteUnico, data.rfcbnmx, fechaNac, resultado);
				$this.props.tagManager({ "type": "EVENT_MISPOLIZAS_APOLIZA-CORRECTOS", "dispositivo": $this.props.dispositivo });
			}).catch(error => {
				console.log(error);
				//$this.props.loader(false);
				/*if (error.message.mensaje) {
					$this.props.mostrarMensajePolizaAgregada("Importante", error.message.mensaje);
				} else {
					$this.props.mostrarMensajePolizaAgregada("ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
				}*/
			});

		}


		agregarPoliza({
			"clienteUnico": this.props.clienteUnico,
			"poliza": poliza,
			"ramo": data.ramo1,
			"vigencia": formatDateDMA(data.iniVigenciaDate),
			"sistemaOrigen": data.sistema,
			"canal": "Portal",
			"certificado": data.certificado,
			"estatus": "Pendiente",
			"grupo": (data.grupo) ? "Grupo" : "Individual",
			"solicitud": formatDateDMA(hoy.getTime()),
			"fecha": hoy.getTime(),
			"timestamp": formatDateDMA(hoy.getTime()) + " " + hoy.toLocaleTimeString()
		}).then(resultado => {
			console.log(resultado);
			$this.props.tagManager({ "type": "EVENT_MISPOLIZAS_APOLIZA-CORRECTOS", "dispositivo": $this.props.dispositivo });
			$this.props.loader(false);
			$("#modal-agregar-poliza").modal({ backdrop: "static", keyboard: false });
			$this.goBack();
			$this.props.setPolizaFalse();
		}).catch(error => {
			console.log(error);
			$this.props.loader(false);
			if (error.message.mensaje) {
				$this.props.mostrarMensajePolizaAgregada("Importante", error.message.mensaje);
			} else {
				$this.props.mostrarMensajePolizaAgregada("ERROR", "Lo sentimos, podrias intentarlo nuevamente.");
			}
		});
	}

	goBack = () => {
		console.log("goBack corriendo");
		this.setState({
			"agregarPoliza": false,
			"videollamada": false
		});
	}

	render() {
		let _this = this;
		let totalPolizas = this.props.autos.length + this.props.gm.length + this.props.danios.length + this.props.vida.length;
		let vidaPolizas = this.props.vida.length;
		let daniosPolizas = this.props.danios.length;
		let gmPolizas = this.props.gm.length;
		let autosPolizas = this.props.autos.length;
		let iPolizas = 0;
		let polizas = [];
		const {modalDin} = this.state;

		switch (this.state.ramo) {
			case "Autos":
				iPolizas = this.props.polizasAutos;
				polizas = this.props.autos;
				break;
			case "Gastos Médicos Mayores":
				iPolizas = this.props.polizasGm;
				polizas = this.props.gm;
				break;
			case "Vida":
				iPolizas = this.props.polizasVida;
				polizas = this.props.vida;
				break;
			case "Daños":
				iPolizas = this.props.polizasDanios;
				polizas = this.props.danios;
				break;
			case "Todas":
				iPolizas = totalPolizas;
				break;
		}

		polizas = polizas.sort(function (a, b) { return a.generales.numPoliza.toString().localeCompare(b.generales.numPoliza.toString()); });

		return (
			<div className="container">
				<ModalDinamico show={this.state.showModal} closeModalFn={(show)=>{this.setState({showModal:show})}} hasClose={modalDin.hasClose} 
				titulo={modalDin.titulo} imagenHeaderUrl={modalDin.imagenHeaderUrl} mensaje={modalDin.mensaje} 
				textoBotonDerecho={modalDin.txtBtnDer} textoBotonIzquierdo={modalDin.txtBtnIzq} funcionBotonDerecho={modalDin.fnBtnDer} funcionBotonIzquierdo={modalDin.fnBtnIzq} />
				{!this.state.verPolizas &&
					<DetallePoliza verPolizas={this.verPolizas} />
				}
				{this.state.verPolizas &&
					<div>
						<div className="second-menu text-center hide-mobile">
							<ul className="clearfix">
								<li>
									<a className={this.state.tabTodas} onClick={this.selectTab.bind(this, ["tabTodas"])}>Todas ({totalPolizas})</a>
								</li>
								<li>
									<a className={this.state.tabAutos} onClick={this.selectTab.bind(this, ["tabAutos"])}>Autos ({autosPolizas})</a>
								</li>
								<li>
									<a className={this.state.tabGm} onClick={this.selectTab.bind(this, ["tabGm"])}>GMM ({gmPolizas})</a>
								</li>
								<li>
									<a className={this.state.tabVida} onClick={this.selectTab.bind(this, ["tabVida"])}>Vida ({vidaPolizas})</a>
								</li>
								<li>
									<a className={this.state.tabDaños} onClick={this.selectTab.bind(this, ["tabDaños"])}>Daños ({daniosPolizas})</a>
								</li>
							</ul>
						</div>
						<div className="second-menu text-center show-mobile">
							<div className="second-menu-select-mobile">
								<p onClick={this.showMobileTabs}>{this.state.secondMenuTitle} <img src={this.state.arrow[this.state.arrowIndex]}></img></p>
								{this.state.mobileTabs &&
									<ul>
										<li onClick={this.selectTab.bind(this, ["tabTodas", "Todas"])}>
											<a className={this.state.tabTodas}>Todas ({totalPolizas})</a>
										</li>
										<li onClick={this.selectTab.bind(this, ["tabAutos", "Autos"])}>
											<a className={this.state.tabAutos}>Autos ({autosPolizas})</a>
										</li>
										<li onClick={this.selectTab.bind(this, ["tabGm", "GMM"])}>
											<a className={this.state.tabGm}>GMM ({gmPolizas})</a>
										</li>
										<li onClick={this.selectTab.bind(this, ["tabVida", "Vida"])}>
											<a className={this.state.tabVida}>Vida ({vidaPolizas})</a>
										</li>
										<li onClick={this.selectTab.bind(this, ["tabDaños", "Daños"])}>
											<a className={this.state.tabDaños}>Daños ({daniosPolizas})</a>
										</li>
									</ul>
								}
							</div>
						</div>
						{this.state.videollamada &&
							<CallCenterForm onSubmit={this.submit} goBack={this.goBack} loaded={true} />
						}
						{this.state.agregarPoliza &&
							<PolizaForm onSubmit={this.submit} goBack={this.goBack} loaded={true} />
						}
						{!this.state.agregarPoliza && !this.state.videollamada &&
							<div className="container polizas-container">
								<div className="QRPolizas">
									<img src={require("../img/CodigoQROriginal.png")} />
								</div>
								<div className={((this.props.autos.length == 0 && this.state.tabAutos == "active") || (this.props.gm.length == 0 && this.state.tabGm == "active") ||
									(this.props.vida.length == 0 && this.state.tabVida == "active") || (this.props.danios.length == 0 && this.state.tabDaños == "active")) ? "polizas-bg" : this.state.bgClass}></div>
								<div className="header-content clearfix mt-50 header-padding">
									<div className={this.state.showProducto == true ? "hide" : "visualizacion"}>
										<ul className="clearfix polizas-tabs">
											<li name="false">
												<button onClick={this.toggleView} disabled={this.state.cardDisable}>
													<img name="false" alt="list" src={this.state.card ? this.state.images[2] : this.state.images[3]} />
												</button>
											</li>
											<li name="true">
												<button onClick={this.toggleView} disabled={this.state.listDisable}>
													<img name="true" alt="card" src={this.state.card ? this.state.images[1] : this.state.images[0]} />
												</button>
											</li>
											<li>Visualización </li>
										</ul>
										<a className="agregar-a" onClick={this.agregarToggle}>
											<p>Agregar póliza</p>
											<img src={require("../img/icon-add.svg")}></img>
										</a>
									</div>
									<div className={this.state.showProducto == true ? "hide" : "numero-polizas"}>
										<h6 className="last-login"><small>Información actualizada al: {this.props.lastlogin}</small></h6>
										<h4>{this.state.ramo}</h4>
										<h4>{iPolizas} {iPolizas == 1 ? "Póliza" : "Pólizas"} </h4>
									</div>
								</div>
								<div className="cards-wrap mt-25 border-box">
									{this.state.card &&
										<div className="row max-width">
											{polizas.map((item, i) =>
												<CardPoliza item={item} key={i} setDetalle={this.setDetalle} onViaNomina = {this.showModalViaNomina} />
											)}

											{this.state.tabTodas == "active" &&
												<div>
													{this.props.autos.length != 0 &&
														<div className="clearfix">
															<h1 className="todas-titulo">Autos</h1>
															{this.props.autos && this.props.autos.map((item, i) =>
																<CardPoliza item={item} key={i} setDetalle={this.setDetalle} ramo="autos" onViaNomina = {this.showModalViaNomina} />
															)}
														</div>
													}
													{this.props.gm.length != 0 &&
														<div className="clearfix">
															<h1 className="todas-titulo">Gastos Médicos Mayores</h1>
															{this.props.gm && this.props.gm.map((item, i) =>
																<CardPoliza item={item} key={i} setDetalle={this.setDetalle} onViaNomina = {this.showModalViaNomina} />
															)}
														</div>
													}
													{this.props.danios.length != 0 &&
														<div className="clearfix">
															<h1 className="todas-titulo">Daños</h1>
															{this.props.danios && this.props.danios.map((item, i) =>
																<CardPoliza item={item} key={i} setDetalle={this.setDetalle} onViaNomina = {this.showModalViaNomina} />
															)}
														</div>
													}
													{this.props.vida.length != 0 &&
														<div className="clearfix">
															<h1 className="todas-titulo">Vida</h1>
															{this.props.vida && this.props.vida.map((item, i) =>
																<CardPoliza item={item} key={i} setDetalle={this.setDetalle} onViaNomina = {this.showModalViaNomina} />
															)}
														</div>
													}
												</div>
											}
										</div>
									}
									{!this.state.card &&
										<div className={this.state.claseLista}>
											{((this.props.autos.length != 0 && this.state.tabAutos == "active") || (this.props.gm.length != 0 && this.state.tabGm == "active") ||
												(this.props.vida.length != 0 && this.state.tabVida == "active") || (this.props.danios.length != 0 && this.state.tabDaños == "active")) &&
												<div className="row hide-mobile">
													<div className="col-xs-3 lista-titulo">
														<img src={require("../img/icon_poliza.png")} alt="" />
														No. Póliza:
													</div>
													<div className="col-xs-3 lista-titulo" style={{ "textAlign": "center" }}>
														Descripción
													</div>
													<div className="col-xs-3 lista-titulo center-text">
														Recibo pendiente de pago
													</div>
													<div className="col-xs-3 lista-titulo">
														Vigencia
													</div>
												</div>
											}
											<ul className="polizas-ul">
												{polizas.map((item, i) =>
													<ListPoliza item={item} key={i} setDetalle={this.setDetalle} />
												)}

												{this.state.tabTodas &&
													<div>
														{this.props.autos.length != 0 &&
															<div className="lista-wrap" style={{ "position": "relative", "padding": "5px 15px" }}>
																<h1 className="todas-h1">Autos</h1>
																<p className="todas-p">{this.props.autos.length} Pólizas</p>
																<span className="todas-span" onClick={this.toggleTodas.bind(this, "autosArrowIndex")}>
																	<img src={this.state.arrow[this.state.autosArrowIndex]} />
																</span>
																{this.state.autosArrowIndex == 1 &&
																	<div className="todas-top">
																		<li className="row hide-mobile">
																			<div className="col-xs-3 lista-titulo">
																				<img src={require("../img/icon_poliza.png")} alt="" />
																				No. Póliza:
																			</div>
																			<div className="col-xs-3 lista-titulo" style={{ "textAlign": "center" }}>
																				Descripción
																			</div>
																			<div className="col-xs-3 lista-titulo center-text">
																				Recibo pendiente de pago
																			</div>
																			<div className="col-xs-3 lista-titulo">
																				Vigencia
																			</div>
																		</li>
																	</div>
																}
																{this.props.autos && this.state.autosArrowIndex == 1 && this.props.autos.map((item, i) =>
																	<ListPoliza item={item} key={i} setDetalle={this.setDetalle} />
																)}
															</div>
														}
														{this.props.gm.length != 0 &&
															<div className="lista-wrap" style={{ "position": "relative", "padding": "5px 15px" }}>
																<h1 className="todas-h1">Gastos Médicos Mayores</h1>
																<p className="todas-p">{this.props.gm.length} Pólizas</p>
																<span className="todas-span" onClick={this.toggleTodas.bind(this, "gmArrowIndex")}>
																	<img src={this.state.arrow[this.state.gmArrowIndex]} />
																</span>
																{this.state.gmArrowIndex == 1 &&
																	<div className="todas-top">
																		<li className="row hide-mobile">
																			<div className="col-xs-3 lista-titulo">
																				<img src={require("../img/icon_poliza.png")} alt="" />
																				No. Póliza:
																			</div>
																			<div className="col-xs-3 lista-titulo" style={{ "textAlign": "center" }}>
																				Descripción
																			</div>
																			<div className="col-xs-3 lista-titulo center-text">
																				Recibo pendiente de pago
																			</div>
																			<div className="col-xs-3 lista-titulo">
																				Vigencia
																			</div>
																		</li>
																	</div>
																}
																{this.props.gm && this.state.gmArrowIndex == 1 && this.props.gm.map((item, i) =>
																	<ListPoliza item={item} key={i} setDetalle={this.setDetalle} />
																)}
															</div>
														}
														{this.props.danios.length != 0 &&
															<div className="lista-wrap" style={{ "position": "relative", "padding": "5px 15px" }}>
																<h1 className="todas-h1">Daños</h1>
																<p className="todas-p">{this.props.danios.length} Pólizas</p>
																<span className="todas-span" className="todas-span" onClick={this.toggleTodas.bind(this, "dañosArrowIndex")}>
																	<img src={this.state.arrow[this.state.dañosArrowIndex]} />
																</span>
																{this.state.dañosArrowIndex == 1 &&
																	<div className="todas-top">
																		<li className="row hide-mobile">
																			<div className="col-xs-3 lista-titulo">
																				<img src={require("../img/icon_poliza.png")} alt="" />
																				No. Póliza:
																			</div>
																			<div className="col-xs-3 lista-titulo" style={{ "textAlign": "center" }}>
																				Descripción
																			</div>
																			<div className="col-xs-3 lista-titulo center-text">
																				Recibo pendiente de pago
																			</div>
																			<div className="col-xs-3 lista-titulo">
																				Vigencia
																			</div>
																		</li>
																	</div>
																}
																{this.props.danios && this.state.dañosArrowIndex == 1 && this.props.danios.map((item, i) =>
																	<ListPoliza item={item} key={i} setDetalle={this.setDetalle} />
																)}
															</div>
														}

														{this.props.vida.length != 0 &&
															<div className="lista-wrap" style={{ "position": "relative", "padding": "5px 15px" }}>
																<h1 className="todas-h1">Vida</h1>

																<p className="todas-p">{this.props.vida.length} Pólizas</p>
																<span className="todas-span" onClick={this.toggleTodas.bind(this, "vidaArrowIndex")}>
																	<img src={this.state.arrow[this.state.vidaArrowIndex]} />
																</span>
																{this.state.vidaArrowIndex == 1 &&
																	<div className="todas-top">
																		<li className="row hide-mobile">
																			<div className="col-xs-3 lista-titulo">
																				<img src={require("../img/icon_poliza.png")} alt="" />
																				No. Póliza:
																			</div>
																			<div className="col-xs-3 lista-titulo" style={{ "textAlign": "center" }}>
																				Descripción
																			</div>
																			<div className="col-xs-3 lista-titulo center-text">
																				Recibo pendiente de pago
																			</div>
																			<div className="col-xs-3 lista-titulo">
																				Vigencia
																			</div>
																		</li>
																	</div>
																}
																{this.props.vida && this.state.vidaArrowIndex == 1 && this.props.vida.map((item, i) =>
																	<ListPoliza item={item} key={i} setDetalle={this.setDetalle} />
																)}
															</div>
														}
													</div>
												}
											</ul>
										</div>
									}
								</div>
								{((this.props.autos.length == 0 && this.state.tabAutos == "active") || (this.props.gm.length == 0 && this.state.tabGm == "active") ||
									(this.props.vida.length == 0 && this.state.tabVida == "active") || (this.props.danios.length == 0 && this.state.tabDaños == "active")) &&
									!this.state.showProducto &&
									<div className="sin-polizas-container">
										<div className="sin-polizas-wrap">
											<img src={require("../img/sin-polizas-icon.png")} />
											<span>Aún no tienes contratadas pólizas de este ramo.</span>
											<p>Conoce todos los beneficios que te ofrecen los seguros de {this.state.ramo} GNP.</p>
											<a onClick={this.toggleProducto} className="conoce-mas-btn">Conoce más</a>
										</div>
									</div>
								}
								{(this.props.autos.length == 0 && this.state.tabAutos == "active") &&
									this.state.showProducto &&
									<AutosProducto showArrow={true} goBack={this.toggleProducto} />
								}
								{(this.props.gm.length == 0 && this.state.tabGm == "active") &&
									this.state.showProducto &&
									<GastosProducto showArrow={true} goBack={this.toggleProducto} />
								}
								{(this.props.vida.length == 0 && this.state.tabVida == "active") &&
									this.state.showProducto &&
									<VidaProducto showArrow={true} goBack={this.toggleProducto} />
								}
								{(this.props.danios.length == 0 && this.state.tabDaños == "active") &&
									this.state.showProducto &&
									<DaniosProducto showArrow={true} goBack={this.toggleProducto} />
								}
							</div>
						}
					</div>
				}
				<div className="modal fade modal-msj" id="modal-bienvenido" tabIndex="-1" role="dialog" aria-labelledby="modal-bienvenido" data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className='txt-black'>
								<p>Bienvenido a la nueva experiencia de tu Portal Soy Cliente de GNP.</p><br />
								<p>Recuerda que este mismo usuario y contraseña es válido para el acceso a la aplicación Soy Cliente GNP.</p><br />
								<p>Descárgala en App Store y Google Play.</p>
							</div>
							<div className='text-center aceptar-cancelar-btn mt-20'>
								<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-codigo-pol" tabIndex="-1" role="dialog" aria-labelledby="modal-codigo-polLabel" data-backdrop="static" data-keyboard="false">
					<div id="modal-dialog-c" className="modal-dialog " role="document">
						<div id="modal-content-c" className="modal-content">
							<ModalCodigoVerificacion pol={true} />
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-agregar-poliza" tabIndex="-1" role="dialog" aria-labelledby="modal-agregar-poliza" data-backdrop="static" data-keyboard="false">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div>
								<h5 id='id-modal-title' className="text-center">Solicitud recibida</h5>
							</div>
							<div className='txt-black'>
								<p>En un plazo de 72 horas deberás consultar nuevamente tu información.</p><br />
								<p>IMPORTANTE: No podrás consultar las pólizas donde no te encuentres como Contratante o Asegurado.</p>
							</div>
							<div className='text-center aceptar-cancelar-btn mt-20'>
								<button type='button' className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Polizas);



// WEBPACK FOOTER //
// ./src/home/polizas.cmpt.js